import { PlusIcon } from "@radix-ui/react-icons";
import { useSelector } from "react-redux";
import AddOwnDrinkDrawer from "src/components/own-items/AddOwnDrink";
import OwnDrinkCard from "src/components/own-items/OwnDrinkCard";
import { Button } from "src/components/ui/button";
import { Drink } from "src/lib/db";

export default function OwnDrinks() {
  const ownItems = useSelector((state: any) => state.ownItems);

  return (
    <>
      <h2
        style={{
          fontWeight: "500",
          textAlign: "center",
          gap: "1ch",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Vlastní nápoje{" "}
        <AddOwnDrinkDrawer>
          <Button size="icon">
            <PlusIcon />
          </Button>
        </AddOwnDrinkDrawer>
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(8rem, 1fr))",
          gridTemplateRows: "repeat(auto-fill, 1fr)",
          gap: "2rem",
          padding: "1rem",
        }}
      >
        {ownItems.Drinks.map((drink: Drink) => (
          <OwnDrinkCard key={drink.id} drink={drink} />
        ))}
      </div>
    </>
  );
}
